import { render, staticRenderFns } from "./EditProjectForm.vue?vue&type=template&id=85ed2302"
import script from "./EditProjectForm.vue?vue&type=script&lang=js"
export * from "./EditProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports